import Button from "../Button/Button";
import { useNavigate } from "react-router-dom";
import useAuthService from "../../auth/AuthService";
import { useState } from "react";
 
interface ISidebarProps {
  ActiveItem?: string;
  userRole?: string;
}
 
export const SideBar: React.FC<ISidebarProps> = ({ ActiveItem, userRole }) => {
  const { isAuthenticated } = useAuthService();
  const navigate = useNavigate();
  const Role = userRole;
 
  const [arr, setArr] = useState([
    {
      label: "Profile",
      link: "/settings/profile",
      activeLabel: "profile"
    },
    ...(isAuthenticated && Role === "moderator"
      ? [{
        label: "Listing",
        link: "/settings/listing",
        activeLabel: "listingProfile"
      }]
      : []),
    {
      label: "Notifications",
      link: "/settings/notifications",
      activeLabel: "notifications"
    },
    {
      label: "Security & Privacy",
      link: "/settings/secpriv",
      activeLabel: "securityPrivacy"
    },
    {
      label: "Payment Method",
      link: "/settings/method",
      activeLabel: "payoutMethods"
    },
    // {
    //   label: "Membership History",
    //   link: "/settings/history",
    //   activeLabel: "membershipHistory"
    // },
  ]);
 
 
  const sortedArr = ActiveItem
    ? [
      ...arr.filter(x => x && x.activeLabel === ActiveItem),
      ...arr.filter(x => x && x.activeLabel !== ActiveItem),
    ]
    : arr;
 
 
  const handleClick = (item: any) => {
    const index = arr.indexOf(item);
    if (index > -1) {
      const newArr = [...arr];
      newArr.splice(index, 1);
      newArr.unshift(item);
      setArr(newArr);
    }
  }
 
  return (
    <div className="profile-side-bar mx-auto p-3">
      <div className="desktop">
        <Button
          variant="dark"
          label="Profile"
          onClick={() => navigate("/settings/profile")}
          className={`button w-100 mb-2 ${ActiveItem === "profile" ? "button-active" : ""
            }`}
        />
        {isAuthenticated && Role === "moderator" && (
          <Button
            variant="dark"
            label="Listing"
            onClick={() => navigate("/settings/listing")}
            className={`button w-100 my-2 ${ActiveItem === "listingProfile" ? "button-active" : ""
              }`}
          />
        )}
        <Button
          variant="dark"
          label="Notifications"
          onClick={() => navigate("/settings/notifications")}
          className={`button w-100 my-2 ${ActiveItem === "notifications" ? "button-active" : ""
            }`}
        />
        <Button
          variant="dark"
          label="Security & Privacy"
          onClick={() => navigate("/settings/secpriv")}
          className={`button w-100 my-2 py-auto ${ActiveItem === "securityPrivacy" ? "button-active" : ""
            }`}
        />
        <Button
          variant="dark"
          label="Payment Methods"
          onClick={() => navigate("/settings/method")}
          className={`button w-100 my-2 ${ActiveItem === "payoutMethods" ? "button-active" : ""
            }`}
        />
        {/* <Button
          variant="dark"
          label="Membership History"
          onClick={() => navigate("/settings/history")}
          className={`button w-100 mt-2 ${
            ActiveItem === "membershipHistory" ? "button-active" : ""
          }`}
        /> */}
        {/* <Button
          variant="dark"
          label="Preferences"
          onClick={()=>navigate("/display-preference")}
          className={`button w-100 my-2 ${ActiveItem === 'Preferences' ? 'button-active' : ''}`}
        /> */}
 
        {/* <ul
          className="ps-0 navbar-nav custom-navbar"
          style={{ listStyleType: "none" }}
        >
          <li className={`nav-item ${ActiveItem === 'editProfile' ? 'active' : ''}`}>
            <Link
              to="/user-profile"
              className="nav-link text-decoration-none"
            >
              Edit Profile
            </Link>
          </li>
          <li className={`nav-item ${ActiveItem === 'myListing' ? 'active' : ''}`}>
            <Link
              to="/my-listing"
              className="nav-link text-decoration-none"
            >
              My Listing
            </Link>
          </li>
          <li className={`nav-item ${ActiveItem === "notifications" ? 'active' : ''}`}>
            <Link
              to="/notification"
              className="nav-link text-decoration-none"
            >
              Notification
            </Link>
          </li>
          <li className={`nav-item ${ActiveItem === "securityPrivacy" ? 'active' : ''}`}>
            <Link
              to="/security-privacy"
              className="nav-link text-decoration-none"
            >
              Security and Privacy
            </Link>
          </li>
          <li className={`nav-item ${ActiveItem === "payoutMethods" ? 'active' : ''}`}>
            <Link
              to="/payout-method"
              className="nav-link text-decoration-none"
            >
              Payment Method
            </Link>
          </li>
          <li className={`nav-item ${ActiveItem === "displayMode" ? 'active' : ''}`}>
            <Link
              to="/display-preference"
              className="nav-link text-decoration-none"
            >
              Display
            </Link>
          </li>
        </ul> */}
      </div>
      <div className="mobile w-100">
        {sortedArr
          .filter(Boolean)
          .map((item: any) => (
            <Button
              key={item.label}
              variant="dark"
              label={item.label}
              onClick={() => {
                handleClick(item);
                navigate(item.link);
              }}
              className={`button font-500-14 w-100 ${ActiveItem === item.activeLabel ? "button-active" : ""
                }`}
            />
          ))}
      </div>
    </div>
  );
};